interface DataPointProps {
  label: string;
  value: string | number;
}

export function DataPoint({ label, value }: DataPointProps) {
  return (
    <div
      className="flex flex-col px-4 py-3 border border-neutral-200 dark:border-neutral-700
                 rounded-md shadow-lg shadow-neutral-100 dark:shadow-black/30"
    >
      <span className="uppercase text-xs font-bold mb-1">{label}</span>
      <span className="text-2xl">{value}</span>
    </div>
  );
}
